import React from 'react';
import { Paper, Typography, CircularProgress } from "@material-ui/core";

export const LoadingIndicator = () => {
  const styles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: "200px",
    height: "200px",
    marginLeft: "-100px",
    marginTop: "-100px",
    position: 'absolute',
    top: '40%',
    left: '50%',
  };
  return <Paper elevation={5} style={styles}>
    <Typography variant="h4">Loading</Typography>
    <CircularProgress disableShrink></CircularProgress>
  </Paper>
};


export default LoadingIndicator;